import privateHttpClient from '../privateHttpClient';
import CityTaxAutoMapper from '../mappers/CityTaxAutoMapper';
import { urlHttpGov } from '../../urls';
import { ICityTaxAuto, ICityTaxAutoFile } from '../../../interfaces';
import CityTaxAutoFileMapper from '../mappers/CityTaxAutoFileMapper';

class CityTaxesAutoService {
    private baseURL: string = `${urlHttpGov}/panel/taxes-auto`;
    private baseURLFile: string = `${urlHttpGov}/panel/taxes-auto-file`;

    async listCityTaxesAuto(cityId: number, signal: AbortSignal): Promise<Array<ICityTaxAuto>> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}`, { signal });

        return data.map((tax: any) => CityTaxAutoMapper.toDomain(tax));
    }

    async createTaxesAuto(importTaxe: FormData): Promise<string> {

        const { data } = await privateHttpClient.post(`${this.baseURL}/import`, importTaxe, {
            headers: {
                "Content-Type": 'multipart/form-data'
            }
        });

        return data.message;
    }

    async listCityTaxesAutoFile(cityId: number, signal: AbortSignal): Promise<Array<ICityTaxAutoFile>> {
        const { data } = await privateHttpClient.get(`${this.baseURLFile}/county/${cityId}`, { signal });

        return data.map((tax: any) => CityTaxAutoFileMapper.toDomain(tax));
    }

    async downloadCityTaxesAutoFile(file_name: string, signal: AbortSignal): Promise<string> {
        const { data } = await privateHttpClient.get(`${this.baseURLFile}/download/${file_name}`, { signal });

        return data.fileUrl;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CityTaxesAutoService();
